<button
  #button
  [class]="'lex-button ' + buttonClass + ' ' + variant"
  [disabled]="isDisabled"
  (click)="handleOnClick()"
  [title]="
    isDisabled ? lextranslate.i18n['49e6c9f1-5997-4373-800f-de178182c92f'] : ''
  "
>
  <em *ngIf="icon" class="material-icons lex-button__icon">{{ icon }}</em>
  <span class="lex-button__span">{{ label }}</span>
</button>
